import { DOCUMENT } from '@angular/common'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(@Inject(DOCUMENT) private document: Document) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let store
		let token
		try {
			store = this.document['mercuryStore']
			token = JSON.parse(document[store + '-currentToken'])
		} catch {}
		try {
			store = localStorage.getItem('store')
			token = JSON.parse(localStorage.getItem(store + '-currentToken'))
		} catch {}
		if (token && req.url.includes(environment.apiUrl)) {
			const changedReq = req.clone({ headers: req.headers.set('Authorization', token.token) })
			return next.handle(changedReq)
		}
		return next.handle(req)
	}
}
